import { nakshatraMap } from "@ishvaram/domain-data";
import type { CustomerLanguage } from "@/lib/customer-language";
import type { NaamAksharOption } from "@/lib/api/matching-naam";

/**
 * One CONFIRMED (nakshatra, pada) cell, plus the labels needed to show it back.
 *
 * The ids are what the score endpoint takes; the labels are display only. The
 * server re-looks-up the cell regardless, so a wrong label can mislead a reader
 * but can never change the number — which is why the label comes from the same
 * governed projection the picker renders.
 */
export interface NaamCell {
  moon_nakshatra: string;
  pada: number;
  nakshatra_label: string;
  syllable: string;
}

export function cellFromOption(option: NaamAksharOption, language: CustomerLanguage): NaamCell {
  return {
    moon_nakshatra: option.moon_nakshatra,
    pada: option.pada,
    nakshatra_label: nakshatraLabel(option.moon_nakshatra, language),
    syllable: option.syllable_hi || option.syllable_en,
  };
}

export function nakshatraLabel(id: string, language: CustomerLanguage): string {
  const nakshatra = nakshatraMap[id as keyof typeof nakshatraMap];
  if (!nakshatra) return id;
  return language === "hi" ? nakshatra.name_hi : nakshatra.name_en;
}
